import { Injectable } from '@angular/core';
import { Http, Response, Request, RequestMethod } from '@angular/http';


@Injectable()
export class DiamondPayDataService {
  constructor(private http: Http) { }

  public RetrieveDiamondCoreInitiatedTransactions() {
    return this.http.get("/api/college_pay/retrieve_matches")
            .map((response: Response) => <any[]>response.json());
  }

  public RetrieveDiamondPayTransactions() {
    return this.http.get("/api/college_pay/retrieve_recurring_transactions")
            .map((response: Response) => <any[]>response.json());
  }

  public RetrieveDiamondPayTransaction(id: string) {
    return this.http.get("/api/diamond_pay/retrieve_matched_transaction/" + id)
            .map((response: Response) => <any[]>response.json());
  }

  public RetrieveRelatedDisbursements(studentId: string) {
    return this.http.get("/api/diamond_pay/disbursements/" + studentId)
            .map((response: Response) => <any[]>response.json());
  }

  public RetrieveUnmatchedTransactions() {
    return this.http.get("/api/college_pay/retrieve_unmatched_transactions")
            .map((response: Response) => <any[]>response.json());
  }

  public retrieveUnmatchedTransaction(id) {
    return this.http.get("/api/college_pay/retrieve_unmatched_transaction/" + id)
            .map((response: Response) => <any>response.json());
  }

  public saveUnmatchedTransaction(transaction: any) {
    return this.httpPost('/api/diamond_pay/update_unmatched_transaction', { transaction: transaction });
  }

  public attemptToMatchUnmatchedTransaction(transaction: any) {
    return this.httpPost('/api/diamond_pay/attempt_match', { transaction: { id: transaction.id } })
               .map((response: Response) => <any>response.json());
  }

  public archiveTransaction(transaction: any) {
      return this.httpPost('/api/diamond_pay/archive_transaction', { transaction: { id: transaction.id } })
               .map((response: Response) => <any>response.json());
  }

  public moveToUnmatched(diamondPayTransactionId: string) {
    return this.httpPost('/api/diamond_pay/move_to_unmatched', { diamond_pay_transaction_id: diamondPayTransactionId })
                .map((response: Response) => <any>response.json());
  }

  public retrieveArchivedTransactions() {
      return this.http.get("/api/diamond_pay/retrieve_archived_transactions")
            .map((response: Response) => <any>response.json());
  }

  public retrieveArchivedTransaction(convergeExportLogId: string) {
      return this.http.get("/api/diamond_pay/retrieve_archived_transaction/" + convergeExportLogId)
            .map((response: Response) => <any>response.json());
  }

  public retrieveCurrentBatchTransactions() {
      return this.http.get("/api/diamond_pay/retrieve_current_batch_transactions")
                .map((response: Response) => <any>response.json());
  }

  public unarchiveTransaction(transaction: any) {
      return this.httpPost('/api/diamond_pay/unarchive_transaction', { transaction: { id: transaction.id }})
                .map((response: Response) => <any>response.json());
  }

  public sendToCurrentBatch(filter) {
      return this.httpPost('/api/diamond_pay/move_to_current_batch', { diamond_pay_transaction_ids: filter.map(log => log.id)})
                .map((response: Response) => <any>response.json());
  }

  public removeFromCurrentBatch(transaction) {
      return this.httpPost('/api/diamond_pay/remove_from_current_batch', { diamond_pay_transaction_id: transaction.id })
                .map((response: Response) => <any>response.json());
  }

  public processQueuedTransactions(transaction_ids) {
      return this.httpPost('/api/diamond_pay/process_batch', { transaction_ids: transaction_ids })
                    .map((response: Response) => <any>response.json());
  }

  private httpPost(url, body) {
    var request = new Request({
                                url: url,
                                method: RequestMethod.Post,
                                body: body
                              });
    var token = document.getElementsByName('csrf-token')[0]['content'];
    request.headers.set('X-CSRF-Token', token);
    return this.http.request(request);
  }

}



// WEBPACK FOOTER //
// ./src/app/diamond-pay-data-service.service.ts